import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

// Restore customer request
export const restoreCustomerRequest = createAction('[Restore Customer] Restore Customer request', props<{ customerId: string }>());

export const restoreCustomerSuccess = createAction('[Restore Customer] Restore Customer Success', props<{ response: string }>());

export const restoreCustomerFailure = createAction('[Restore Customer] Restore Customer Failure', props<{ error: IGenericError<ErrorResponse> }>());

export const clearRestoreCustomerRequest = createAction('[Restore Customer] Clear Restore Customer request');
